import { render } from "./RenderView.vue?vue&type=template&id=37b0e2e3"
import script from "./RenderView.vue?vue&type=script&lang=js"
export * from "./RenderView.vue?vue&type=script&lang=js"
script.render = render

export default script